import Lenis from "@studio-freight/lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin.js";
var styleDir = object_name.stylesheetDirectory;

const story = document.getElementById("story");
if (story) {
  const shotField = document.getElementById("shot-field");
  const numberOfShots = 400; // Adjust the number as needed
  let shots = []; // Array to store shot elements

  function createShots() {
    for (let i = 0; i < numberOfShots; i++) {
      const shot = document.createElement("img");
      shot.classList.add("shot");

      // Add the "shot-2" class to every second element
      if (i % 5 !== 4) {
        // As arrays are 0-indexed, odd indices represent every second element
        shot.classList.add("shot", "shot-2");
      }

      shot.setAttribute(
        "src",
        styleDir + "/includes/assets/img/smaller-shot.png"
      );
      shots.push(shot); // Store the shot
      shotField.appendChild(shot);
    }
  }
  function placeShots() {
    // Central area dimensions in pixels
    const centralAreaWidthPx = 550;
    const centralAreaHeightPx = 300;

    // Calculate central area in percentages
    const centralAreaXPercent =
      50 - (centralAreaWidthPx / shotField.offsetWidth) * 50;
    const centralAreaYPercent =
      50 - (centralAreaHeightPx / shotField.offsetHeight) * 50;
    const centralAreaWidthPercent =
      (centralAreaWidthPx / shotField.offsetWidth) * 100;
    const centralAreaHeightPercent =
      (centralAreaHeightPx / shotField.offsetHeight) * 100;

    shots.forEach((shot) => {
      let xPercent, yPercent;
      do {
        xPercent = Math.random() * 100;
        yPercent = Math.random() * 100;
      } while (
        isInCentralArea(
          xPercent,
          yPercent,
          centralAreaXPercent,
          centralAreaYPercent,
          centralAreaWidthPercent,
          centralAreaHeightPercent
        )
      );

      shot.style.left = `${xPercent}%`;
      shot.style.top = `${yPercent}%`;
    });
  }

  function isInCentralArea(x, y, centerX, centerY, width, height) {
    return (
      x > centerX && x < centerX + width && y > centerY && y < centerY + height
    );
  }

  // Debounce function to limit resize handling
  function debounce(func, wait, immediate) {
    let timeout;
    return function () {
      const context = this,
        args = arguments;
      const later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  // Initial creation and placement
  createShots();
  placeShots();

  // Handle resize events with debouncing
  window.addEventListener("resize", debounce(placeShots, 250));

  gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
  const lenis = new Lenis({
    smoothWheel: true,
    smoothTouch: false,
  });
  lenis.on("scroll", ScrollTrigger.update);

  //   const tl = gsap.timeline({ delay: 4.5 });
  // Get all the elements with the class .text-in

  const mainTl = gsap.timeline({
    scrollTrigger: {
      pin: true,
      trigger: "#story",
      start: "top top",
      //   end: "bottom bottom", // Adjust this value
      // start: "bottom bottom",
      end: `${window.innerHeight * 5}px`,
      scrub: true,
      markers: false,
    },
  });

  mainTl.to("#shell", {
    y: 205,
    x: 45,
    rotation: -105,
  });
  mainTl.to("#intro-title", {
    opacity: 1,
    delay: 1,
  });

  mainTl.to({}, { duration: 3 });

  const shots1 = document.querySelectorAll(".shots-1");
  const animateshots1 = (start, end) => {
    for (let iS1 = start; iS1 < end; iS1++) {
      mainTl.to(
        shots1[iS1],
        {
          y: 0,
          opacity: 1,
          ease: "Expo.easeOut",
        },
        "+=.2"
      );
    }
    mainTl.add(() => {}, "+=.3");
  };

  // Animate text elements based on ranges
  animateshots1(0, 3);

  const title1Elements = document.querySelectorAll(".title-1");
  title1Elements.forEach((element, index) => {
    mainTl.to(
      element,
      {
        y: 0,
        opacity: 1,
        ease: "Expo.easeOut",
      },
      "+=" + index * 0.2
    ); // Stagger each element by 0.1 seconds
  });

  animateshots1(3, 6);

  // const shotsInField = document.querySelectorAll(".shot-in-field");
  // const animateshotsInField = (start, end) => {
  //   for (let iS2 = start; iS2 < end; iS2++) {
  //     mainTl.to(shotsInField[iS2], {
  //       y: 0,
  //       opacity: 1,
  //       duration: 0.1,
  //       ease: "Expo.easeOut",
  //     });
  //   }
  //   mainTl.add(() => {}, "+=0");
  // };

  // animateshotsInField(0, 46);

  mainTl.call(placeShots());

  mainTl.to("#story-container", {
    y: "-100vh",
    duration: 6,
  });
  mainTl.addLabel("startConcurrentAnimations");
  const title2Elements = document.querySelectorAll(".title-2");
  title2Elements.forEach((element, index) => {
    mainTl.to(
      element,
      {
        y: 0,
        opacity: 1,
        ease: "Expo.easeOut",
      },
      "+=" + index * 0.1
    ); // Stagger each element by 0.1 seconds
  });

  mainTl.to("#title-2", {
    opacity: 0,
  });

  const title3Elements = document.querySelectorAll(".title-3");
  title3Elements.forEach((element, index) => {
    mainTl.to(
      element,
      {
        y: 0,
        opacity: 1,
        ease: "Expo.easeOut",
      },
      "+=" + index * 0.1
    ); // Stagger each element by 0.1 seconds
  });

  const shot2 = document.querySelectorAll(".shot-2");
  const animateshot2 = (start, end) => {
    for (let iS3 = start; iS3 < end; iS3++) {
      let delay = iS3 * 0.08;
      mainTl.to(
        shot2[iS3],
        {
          y: 0,
          opacity: 1,
          duration: 0.1,
          ease: "Expo.easeOut",
        },
        "startConcurrentAnimations+=" + delay
      );
    }
  };

  animateshot2(0, 320);

  // Animate text elements based on ranges

  const circleT = gsap.timeline({
    scrollTrigger: {
      pin: true,
      trigger: "#circle-t",
      start: "top top",
      end: `${window.innerHeight}px`,
      scrub: true,
      markers: false,
    },
  });

  const circletitle = document.querySelectorAll(".circle-title-in");

  circletitle.forEach((element, index) => {
    circleT.to(
      element,
      {
        y: 0,
        opacity: 1,
        ease: "Expo.easeOut",
      },
      "+=" + index * 0.2
    ); // Stagger each element by 0.1 seconds
  });

  circleT.to({}, { duration: 1 });

  // const circleTl = gsap.timeline({
  //   scrollTrigger: {
  //     pin: true,
  //     trigger: "#story-3",
  //     start: "top top",
  //     end: `${window.innerHeight * 5}px`,
  //     scrub: true,
  //     markers: false,
  //   },
  // });

  // const CirclePanels = document.querySelectorAll(".circle-panel");
  // let delayTime = 0; // Initial delay time

  // CirclePanels.forEach((el, index) => {
  //   var cImage = el.querySelector(".circle-image");
  //   var cTitle = el.querySelector(".circle-title");
  //   var cText = el.querySelector(".circle-text");
  //   var cButton = el.querySelector(".circle-button");

  //   // Set the z-index and animate each element with incremental delays
  //   circleTl.to(el, { zIndex: 10 }, delayTime);
  //   circleTl.to(cImage, { opacity: 1, scale: 1 }, (delayTime += 0.5)); // Increment delay time
  //   circleTl.to(cTitle, { opacity: 1 }, (delayTime += 0.5));
  //   circleTl.to(cText, { opacity: 1 }, (delayTime += 1));
  //   circleTl.to(cButton, { opacity: 1 }, (delayTime += 0.5));
  //   delayTime += 3;
  //   if (index !== CirclePanels.length - 1) {
  //     circleTl.to(el, { opacity: 0 }, (delayTime += 0.5));
  //   }

  //   // Increment the delay for the next set of animations
  // });

  // // Add a pause at the end if needed
  // circleTl.add(() => {}, "+=2");
}
